import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { FolderSection, LabelValue, InspectionBadgeStatus } from '../Elements';
import Translate, { t } from '../../common/Translate';
import { useInspection } from '../../../hooks/useCalendar/useRecordBlocs/useInspection';

export const InspectionBloc = ({ recordId, formId }) => {
  const {
    goToInspection,
    active,
    isLoading,
    status,
    totals,
    localStatus,
    condiDisplayPdfLink,
    downloadPdf,
    newPdfUrl,
    bee2LinkDate,
    message,
    showNewPdf,
    recordStatus,
    recordType,
  } = useInspection({ recordId, formId });
  return (
    <>
      <FolderSection
        title={t(Number(recordType) !== 2 ? 'expert_report' : 'counter-appraisal')}
        dataTestid="inspection-bloc"
        action={goToInspection}
        isLoading={isLoading}
        showArrow={active}
      >
        {totals.map(({ label, value }) => (
          <LabelValue label={label} key={label} value={value} />
        ))}
        {/* ||
        (active && [1].includes(status) && <MessageValue label={t('start_appraisal')} />) ||
        (active && [2, 3, 4, 5].includes(status) && (
          <MessageValue
            label={t('continue_appraisal')}
            // value={corrected >= 0 ? corrected : t("info_indispo")}
          />
        ))} */}
        <InspectionBadgeStatus status={status} localStatus={localStatus} recordStatus={recordStatus} />
        <Row className="mt-2">
          <Col xs="8" sm="3" lg="5">
            {condiDisplayPdfLink && (
              <Row>
                <a
                  target="_blank"
                  data-testid="pdf-download-link"
                  href={showNewPdf ? newPdfUrl : downloadPdf}
                  className="download-btn"
                  rel="noopener noreferrer"
                  id="theHref"
                >
                  <Translate code="download" />
                </a>
              </Row>
            )}
          </Col>
        </Row>
        {bee2LinkDate && (
          <Row className="mt-2">
            <Col className="label">
              <strong>{bee2LinkDate}</strong> : {message}
            </Col>
          </Row>
        )}
      </FolderSection>
    </>
  );
};

InspectionBloc.propTypes = {
  recordId: PropTypes.number,
  formId: PropTypes.number,
};

InspectionBloc.defaultProps = {
  recordId: '',
  formId: null,
};
